const styles = (theme) => ({
    rowColor: {
        backgroundColor: '#ffbe00'
    },
    reportContainer: {
        marginLeft: '5px',
        marginRight: '5px',
        marginTop: '18px'
    },
    searchIconB: {
        marginLeft: -30,
        color: '#005F9E'
    },
    noHeight: {
        height: '0%'
    },
    paperRoot: {
        boxShadow: 'unset'
    },
    paperList: {
        backgroundColor: '#fff',

        boxShadow: 'unset'
    },
    titleBar: {
        fontSize: 21,
        color: '#000000 !important',
        fontWeight: 600,
        marginTop: '0.5rem',
        paddingLeft: 10
    },
    metricPadding: {
        padding: '20px 50px'
    }
});

export default styles;
